import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone: false,
  selector: 'app-our-services',
  templateUrl: './our-services.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./our-services.component.scss']
})
export class OurServicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
